
import React from 'react';
import { WeatherCondition } from '@/types/weather';

interface WeatherDetailsProps {
  temperature: number;
  humidity: number;
  windSpeed: number;
  location: string;
  date: Date;
  condition: WeatherCondition;
}

export const WeatherDetails: React.FC<WeatherDetailsProps> = ({ 
  temperature, 
  humidity, 
  windSpeed, 
  location, 
  date, 
  condition 
}) => {
  const getWeatherLabel = () => {
    switch (condition) {
      case 'clear': return 'Clear';
      case 'partlyCloudy': return 'Partly Cloudy';
      case 'cloudy': return 'Cloudy';
      case 'rain': return 'Rain';
      case 'heavyRain': return 'Heavy Rain';
      case 'thunderstorm': return 'Thunderstorm';
      case 'snow': return 'Snow';
      case 'fog': return 'Fog';
      case 'wind': return 'Wind';
      case 'alert': return 'Weather Alert';
      default: return 'Cloudy';
    }
  };
  
  return (
    <>
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-2xl font-bold text-shadow-md drop-shadow-lg">{location}</h2>
          <p className="text-sm opacity-90 text-shadow-md drop-shadow-md">
            {date.toLocaleDateString('en-US', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </p>
        </div>
        <div className="text-right">
          <p className="text-4xl font-bold text-shadow-md drop-shadow-lg">{temperature}°C</p>
          <p className="text-sm opacity-90 text-shadow-md drop-shadow-md">{getWeatherLabel()}</p>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 mt-3 bg-black/30 backdrop-blur-sm p-3 rounded-lg">
        <div>
          <p className="text-sm opacity-90">Humidity</p>
          <p className="font-semibold">{humidity}%</p>
        </div>
        <div>
          <p className="text-sm opacity-90">Wind</p>
          <p className="font-semibold">{windSpeed} km/h</p>
        </div>
      </div>
    </>
  );
};

export default WeatherDetails;
